import React, { useId, useState } from 'react';
import { EDUCATION_SECTIONS, SIGNAL_DISCLAIMER } from '../utils/yieldCurveSignal';

function YieldCurveSlopeHelp() {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="yield-slope-help">
      <button
        type="button"
        className="yield-slope-help-trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        How to read this
      </button>
      {open && (
        <div id={panelId} className="yield-slope-help-panel" role="region" aria-label="Yield curve signal guide">
          {EDUCATION_SECTIONS.map((section) => (
            <div key={section.title} className="yield-slope-help-section">
              <h4 className="yield-slope-help-heading">{section.title}</h4>
              <p className="yield-slope-help-body">{section.body}</p>
            </div>
          ))}
          <p className="yield-slope-help-disclaimer">{SIGNAL_DISCLAIMER}</p>
        </div>
      )}
    </div>
  );
}

export default YieldCurveSlopeHelp;
